export const half_hour_list = () => {
    var times = [];
    for(var i = 0; i < 24; i++){
    for(var j = 0; j < 60; j+=30){
        let hour = (i<10?'0':'') + i;
        let minute = (j<10?'0':'') + j;
        times.push(hour + ":" + minute);
        }
    }
    return times;
}


